export default __webpack_public_path__ + "static/media/ETH.bcc8fad4.svg";